<template>
    <span class="inline-flex p-1 items-center justify-center" :class="`tag tag-${severity}`">
        <Icon v-if="icon" :icon="icon" size="16" />
        <span>{{ value }}</span>
    </span>
</template>

<script setup>
const props = defineProps({
    value: {
        type: String,
        required: true,
        default: ''
    },
    severity: {
        type: String,
        default: ''
    },
    icon: {
        type: String,
        default: null
    }
})
</script>
